import { useEffect } from 'react'
import { connect } from 'react-redux'
import { Redirect, useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { isQuickQuotePath, isFNAPath } from 'quick-quote/components/navigations/tabs'
import { ROUTE_PATH, PATH } from 'quick-quote/constants/path'
import { resetInvestmentPermission } from 'quick-quote/product-investment/validate-permission/actions'

import { getToggles } from '../../feature-toggles'

import { BasicPlanSummary } from './basic-plan-summary'

const getRedirectLink = (location, isOnFnaPhase) => {
  const path = location && location.pathname
  if (isQuickQuotePath(path) && !isOnFnaPhase) {
    return PATH.QUICK_QUOTE + ROUTE_PATH.INVESTMENT.ILP_SALE_SHEET
  } else if (isQuickQuotePath(path) && isOnFnaPhase) {
    return PATH.QUICK_QUOTE + ROUTE_PATH.INVESTMENT.MARKET_CONDUCTS
  } else if (isFNAPath(path)) {
    return getToggles().ENABLE_FNA_V3
      ? PATH.FNA + ROUTE_PATH.INVESTMENT.ILP_SALE_SHEET
      : PATH.FNA + ROUTE_PATH.INVESTMENT.MARKET_CONDUCTS
  } else {
    return ROUTE_PATH.INVESTMENT.ILP_SALE_SHEET
  }
}

const _InvestmentBasicPlan = function(props) {
  const {
    displayProduct,
    isSelected,
    cssClass,
    validateProduct,
    proceedToInvestmentProduct,
    location,
    isOnFnaPhase,
    resetInvestmentPermission,
  } = props

  const history = useHistory()

  useEffect(() => {
    return () => {
      if (['PUSH', 'REPLACE'].includes(history.action)) {
        resetInvestmentPermission()
      }
    }
  }, [])
  const link = getRedirectLink(location, isOnFnaPhase)
  return (
    <div
      key={displayProduct.code}
      className={['product', cssClass, isSelected ? 'selected' : ''].join(' ')}
      data-product-name={displayProduct.displayName}
      data-product-code={displayProduct.code}
      onClick={() => validateProduct(displayProduct, link)}
    >
      <div className="product-card-container">
        <BasicPlanSummary data-testid="basic-plan-summary" displayProduct={displayProduct} isSelected={isSelected} />
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  return {
    displayProduct: props.displayProduct,
    isSelected: props.isSelected,
    cssClass: props.cssClass,
    validateProduct: props.validateProduct,
    proceedToInvestmentProduct: state.investment.proceedToInvestmentProduct,
  }
}

export const InvestmentBasicPlan = connect(mapStateToProps, (dispatch) => ({
  resetInvestmentPermission: bindActionCreators(resetInvestmentPermission, dispatch),
}))(_InvestmentBasicPlan)
